import "./index.css";

import App from "./App";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import TagManager from "react-gtm-module";
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";

const tagManagerArgs = {
  gtmId: "GTM-MBSVZPP",
};

// Only initialize GTM if consent was already given
if (getCookieConsentValue() === "true") {
  TagManager.initialize(tagManagerArgs);
}

const handleAcceptCookies = () => {
  TagManager.initialize(tagManagerArgs);
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <>
    <Router>
      <App />
    </Router>
    <CookieConsent
      enableDeclineButton
      onAccept={handleAcceptCookies}
      buttonText="Accept"
      declineButtonText="Decline"
      buttonStyle={{
        backgroundColor: "#846bb9",
        color: "#fff",
        padding: "0.5rem 1rem",
        borderRadius: "0.375rem",
      }}
      declineButtonStyle={{
        backgroundColor: "#fff",
        color: "#846bb9",
        padding: "0.5rem 1rem",
        borderRadius: "0.375rem",
      }}
    >
      This website uses cookies to enhance the user experience.
    </CookieConsent>
  </>
);
